import RouterConfig from './router'
import { BrowserRouter } from "react-router-dom";

import './reset.css';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouterConfig />
      </BrowserRouter>
    </div>
  );
}

export default App;